export function Overview() {
  return (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
      d="M4 7h3m13 0h-9m9 10h-3M4 17h9m-9-5h16"
    ></path>
  )
}
